import { IPeopleLocation } from "../interfaces/poeple-location.interface";

export class PeopleLocation implements IPeopleLocation {
  peoplelocationcode: string;
  peoplelocationname: string;

  constructor(peopleLocation: IPeopleLocation) {
    Object.keys(peopleLocation).map(key => this[key] = peopleLocation[key]);
  }
}